import {
  Box,
  Button,
  Grid,
  IconButton,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import { closeIcon, saveIcon } from "assets/images";
import { useForm } from "react-hook-form";
import { UpdateSLPContactNotePayload } from "store/slpDashboard/type";
import {
  CONTACT_NOTE_MAX_LENGTH,
  INPUT_VALIDATION_NO_WHITE_SPACE_WITH_SPECIAL_CHARACTER_REGEX,
} from "utils/constants/constant";
import { showLoader } from "utils/helper";
import { getSLPContactNoteError } from "utils/helper/validation-message-helper";
import { IUpdateSLPContactNoteValue } from "utils/interfaces/slp";

export type ISLPContactNoteModalProps = {
  onClose: () => void;
  contactNoteDetail: IUpdateSLPContactNoteValue;
  updateSLPContactNoteRequest: (payload: UpdateSLPContactNotePayload) => {};
  onSaveCallback: () => void;
};

const SLPContactNoteModal = ({
  onClose,
  contactNoteDetail,
  updateSLPContactNoteRequest,
  onSaveCallback,
}: ISLPContactNoteModalProps) => {
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm<IUpdateSLPContactNoteValue>({
    defaultValues: contactNoteDetail,
  });

  const handleSaveClick = (data: IUpdateSLPContactNoteValue) => {
    if (updateSLPContactNoteRequest) {
      showLoader();
      updateSLPContactNoteRequest({
        value: { ...data, note: data.note?.trim() ?? null },
        callback: onSaveCallback,
      });
    }
  };

  return (
    <Modal open onClose={onClose}>
      <Box className="common-modal modal-600">
        <Box className="modal-header">
          <Typography variant="h4">Contact Notes</Typography>
          <IconButton onClick={onClose}>
            <img src={closeIcon} alt="close" />
          </IconButton>
        </Box>
        <form onSubmit={handleSubmit(handleSaveClick)}>
          <Box className="modal-body">
            <Grid container columnSpacing="16px">
              <Grid item xs>
                <TextField
                  className="skills-textarea"
                  label="Contact Note"
                  fullWidth
                  variant="outlined"
                  multiline
                  {...register("note", {
                    maxLength: CONTACT_NOTE_MAX_LENGTH,
                    pattern:
                      INPUT_VALIDATION_NO_WHITE_SPACE_WITH_SPECIAL_CHARACTER_REGEX,
                  })}
                  error={!!errors.note}
                  helperText={getSLPContactNoteError(errors.note)}
                />
              </Grid>
            </Grid>
          </Box>
          <Box className="modal-footer">
            <Button variant="contained" className="btn-save" type="submit">
              <img src={saveIcon} alt="save" />
              Save
            </Button>
            <Button variant="outlined" className="btn-cancel" onClick={onClose}>
              Cancel
            </Button>
          </Box>
        </form>
      </Box>
    </Modal>
  );
};

export default SLPContactNoteModal;
